import React from 'react'

const Network: React.FC = () => {
    return (<></>)
}

export default Network
